"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasMoreReceivedPackages = exports.getPackageFromPackageId = exports.getPackageFromCreationDate = void 0;
var moment_1 = __importDefault(require("moment"));
var getPackageFromCreationDate = function (store, creationDate) {
    var detailsPkg = store.packageDetails.packageDetails;
    if (detailsPkg && moment_1.default(detailsPkg.creationDate).isSame(creationDate)) {
        return detailsPkg;
    }
    var newPkg = store.newPackages.packages.find(function (p) { return moment_1.default(p.creationDate).isSame(creationDate); });
    if (newPkg) {
        return newPkg;
    }
    var recievedPkg = store.receivedPackages.packages.find(function (p) { return moment_1.default(p.creationDate).isSame(creationDate); });
    if (recievedPkg) {
        return recievedPkg;
    }
    return undefined;
};
exports.getPackageFromCreationDate = getPackageFromCreationDate;
var getPackageFromPackageId = function (store, id) {
    var detailsPkg = store.packageDetails.packageDetails;
    if (detailsPkg && detailsPkg.id === id) {
        return detailsPkg;
    }
    var newPkg = store.newPackages.packages.find(function (p) { return p.id === id; });
    if (newPkg) {
        return newPkg;
    }
    var recievedPkg = store.receivedPackages.packages.find(function (p) { return p.id === id; });
    if (recievedPkg) {
        return recievedPkg;
    }
    return undefined;
};
exports.getPackageFromPackageId = getPackageFromPackageId;
var hasMoreReceivedPackages = function (store) {
    return store.receivedPackages.packages.length < store.receivedPackages.totalPackagesCount;
};
exports.hasMoreReceivedPackages = hasMoreReceivedPackages;
